import { useNavigate } from 'react-router-dom';

export const useNavigationWithScroll = () => {
  const navigate = useNavigate();

  const navigateToSection = (path, sectionId = null) => {
    if (sectionId) {
      // Navigate to the page first
      navigate(path);
      
      // Wait for navigation to complete, then scroll to section
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 150); // Slightly longer delay to ensure page loads
    } else {
      // Regular navigation without scroll
      navigate(path);
    }
  };

  return { navigateToSection };
}; 